import {observer} from 'mobx-react-lite'
import React from 'react'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {ItemName} from '@components/common/sandbox/list-view/components/item-name'
import {
  TwCell,
  TwCellFunctions,
  TwCellFunctionsCompensator, TwInnerCell,
  TwRowContainer,
  TwRowShell
} from '@components/common/sandbox/list-view/tw-components'
import * as Tw from '@components/common/sandbox/list-view/tw-components'

interface LiteItemRowProps {
  name: string,
  /**
   * The amount of left margin to apply to the row according to its nesting level provided by the parent component (rows, to be precise)
   */
  marginLeft: number
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const EmptyFunction = () => {
}

export const LiteItemRow = observer((props: LiteItemRowProps) => {
  const {
    name
  } = props


  return <TwRowContainer>
    <TwRowShell style={{
      marginLeft: `${props.marginLeft}px`
    }}>
      <TwCell>
        <TwInnerCell>
          <TwCellFunctions>
            <TwCellFunctionsCompensator />
            <Tw.TwCellFunction>
              <CheckboxNew
                rounded
                size="big"
                color="green"
                value={false}
                onChange={EmptyFunction}
              />
            </Tw.TwCellFunction>
          </TwCellFunctions>
          <ItemName
            value={name}
            isArchived={false}
            isLazy={false}
            color={null}
            completed={false}
            fromBackgroundColor={'from-background-hover'}
          />
        </TwInnerCell>
      </TwCell>
    </TwRowShell>
  </TwRowContainer>
})